import { z } from 'zod';

export const PixSchema = z.object({
  amount: z.string(),
  e2eId: z.string().nullable(),
  key: z.string(),
  status: z.string().optional(),
  qrCodeImage: z.string().nullable(),
  qrCodeText: z.string().nullable(),
});

export type PixCharge = z.infer<typeof PixChargeSchema>['pixCharge'];

export const PixChargeSchema = z.object({
  pixCharge: PixSchema,
});
